<template>
  <div v-if="type == 'marker'">
    <div
      v-cdrag.self="{ id, parent: true, disable: type == 'marker' }"
      :style="{ 'background-color': getMarksColor }"
      class="marker-part"
    >
      <slot></slot>
      <!--   <base-extended-tool-tip v-if="type != 'marker'" :data="data" /> -->
      <div
        class="remove-marker otz-icon no-bg"
        style="
          height: 16px;
          align-items: center;
          display: flex;
          font-size: 12px;
        "
        v-on="$listeners"
      >
        F
      </div>
      <div class="show-colors no-bg" @click="showColors = !showColors">
        <Icons icon="color-picker" height="20px" width="20px" fill="white" />
      </div>
    </div>
    <div class="color-picker" v-if="type == 'marker' && showColors">
      <baseColorPicker
        :show="showColors"
        :color="getMarksColor"
        @input="setColor"
        @hide="showColors = false"
      />
    </div>
  </div>
  <div v-else v-cdrag.self="{ id, parent: true, disable: type == 'marker' }">
    <slot></slot>
    <BaseIcon
      width="28"
      height="28"
      v-on="$listeners"
      :nameIcon="nameIcon"
      pathIcon="icons-ganeral"
      v-if="type != 'marker'"
      v-tooltip="{
        content: data,
        placement: 'right',
        classes: 'extens-tooltip1',
      }"
    />
  </div>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";
import { mapActions } from "vuex";
export default {
  components: { Icons },
  data() {
    return { colors: { hex: "#c67f05" }, showColors: false, reactColor: 0 };
  },
  props: ["type", "id", "item"],
  computed: {
    active() {},
    nameIcon() {
      return `icon-${this.type}-page`;
    },
    data() {
      if (this.type == "key") return this.item.key + " | " + this.item.value;
      if (this.type == "comment") return this.item.data;
      if (this.type == "link") {
        let bookName =
          this.item.bookName == this.item.linkedTo.bookName
            ? ""
            : this.item.linkedTo.bookName + " | ";
        let page = this.$t("general.page") + " " + this.item.linkedTo.letter;
        let note = this.item.note ? " | " + this.item.note : "";
        return bookName + page + note;
      }
    },
    getMarksColor() {
      let react = this.reactColor;
      if (this.item.color == null) this.item.color = "custom";
      return this.item.color != "custom"
        ? this.item.color
        : this.userSettings.settings.marksColor ||
            this.userSettings.settings.subColor ||
            "#c67f05";
    },
  },
  methods: {
    ...mapActions("userPersonalExtensions", ["deleteUserMarker"]),
    edit() {
      // this.$emit("click", this.item, this.type);
    },
    remove() {
      this.$emit("click", this.item, this.type);
      //   this.deleteUserMarker(this.item.id);
    },
  },
  watch: {
    colors: (oldv, newv) => {},
  },
  methods: {
    async setColor(value) {
      this.colors = value;
      this.userSettings.setSettings("marksColor", value.hex);
      await this.updateMarkerColor(value.hex);
      this.reactColor++;
    },
    async updateMarkerColor(color) {
      this.item.color = color;
      await this.$store.dispatch(
        `personalAdditionsTabs/updMarker`,
        { bookKey: this.item.bookId, editKey: this.item },
        {
          root: true,
        }
      );
    },
  },
  created() {
    if (this.type === "marker" && this.item.color === "custom")
      this.updateMarkerColor(this.getMarksColor);
  },
};
</script>

<style lang="scss" scoped>
.remove-marker {
  position: absolute;
  left: 5px;
  top: 5px;
  font-size: 10px;
  color: #000;
  line-height: 12px;
  height: 10px;
}
.show-colors :hover {
  fill: white;
}
.show-colors {
  position: absolute;
  cursor: pointer;
  left: 20px;
  top: 5px;
  font-size: 10px;
  color: #000;
  line-height: 12px;
  height: 10px;
}
.color-picker {
  position: absolute;
  bottom: -65px;
  left: 0px;
}
.marker {
  position: absolute !important;
  .marker-part {
    border: 0 !important;
    z-index: 1999;
    opacity: 0.5;
    height: 100%;
    width: 100%;
  }
}
</style>
